export enum ColumnType {
	Normal = 0,
	Total = 1,
	Custom = 2
}